function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill:#242424;}.st1{fill:#353535;}.st2{opacity:0.6;fill:#191919;enable-background:new    ;}.st3{fill:#FFE11C;}.st4{fill:#FFFFFF;}");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 1920,
  height: 1080
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 680,
  className: "st1",
  width: 1920,
  height: 400
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M1615.3,542.4c-120.8-169.1-123.6-270.1-182.5-295.5c-31-13.3-122.8,33.6-156.1-12.3c-12.6-17.4-48.7-49.2-75.3-40.9c-26.6,8.3-39.9,5.5-70.9,28.9s-38.4,51-60.6,60.6c-22.2,9.6-59.1-13.8-66.5,13.8c-7.4,27.6-1.5,38.6-10.3,60.6c-8.9,22.1-84.3,74.4-107.9,79.9c-23.6,5.5,19.2-9.6-38.4,6.9c-57.6,16.5-71-6.9-104.9,17.9c-34,24.8-26.6,34.5-51.7,57.9c-25.1,23.4-31,42.7-73.9,34.5c-42.9-8.3-88.7-1.4-103.5-37.2c-14.8-35.8,20.7-16.5-20.7-73c-41.4-56.5,34,1.4-63.6-92.3c-97.6-93.7-99-104.7-113.8-102c-14.8,2.8-37,15.2-41.4,62c-4.4,46.9,4.4,77.2-11.8,91C245.1,417,243.6,417,228.8,428c-14.8,11-22.2,26.2-41.4,35.8s-50,19.3-59.1,28.9C45.4,579.9,0,680.2,0,680.2h1721.4C1721.4,680.2,1628.8,561.3,1615.3,542.4z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M552.1,221.7c0,0-13.3,11.5,1.5,27c14.8,15.4,19,5.7,22.4,4.9c3.4-0.8,12.5,12.2,12.5,12.2s116.6,243.8,128.8,278.8c12.3,35,19,43,19,43l-6.1-25.8c0,0-16.2-40.9-18.5-47.6c-2.3-6.7-55-137.1-78.6-183.9c-23.6-46.9-40.9-93.4-55.7-105.3C586,211.1,556,198.2,552.1,221.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M470.9,824c0,13.8,10.2,25.3,25.3,25.3c15.1,0,25.3-11.3,25.3-25.3v-29.3h-50.6C470.9,794.7,470.9,812.2,470.9,824z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M396.6,824c0,13.8,10.2,25.3,25.3,25.3c15.1,0,25.3-11.3,25.3-25.3v-30.2h-50.6C396.6,793.9,396.6,812.2,396.6,824z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M658.4,320.6c-10.5-10.5-25.5-9.7-35.2,0L457.7,486.2c0,0-59.4-58.9-106.3-105.4c10.6-1,32.6-8,39.9-10.4c4.9,32.3,32.7,57,66.3,57c37.1,0,67.1-30,67.1-67.1c0-8.9-1.7-17.3-4.8-25c14.1-5.5,58.6-24,54.2-37.6c-5.1-16-62.9,16.7-62.9,16.7s-32.7-48.8-57.8-62.9c-25-14.1-61.6,22.5-92.4,31.5c-30.8,9-63.8,35.8-54.6,34.7c10.3-1.3,37.9-12.2,61.6-13.5c23.8-1.3,16,44.3,16,50.1c0,0-29.6,14.8-37,22.4c-27.3-27.1-49.4-49-51.2-50.8c-9.6-9.6-24.7-10.5-35.2,0c-10.5,10.5-9.7,25.5,0,35.2c0,0,111.4,111.4,116.4,116.4c0.5,0.5,1,1,1.6,1.4l0,306.8h157.8V476.3c1.9-1.1,3.7-2.5,5.4-4.2c0,0,111.4-111.4,116.4-116.4C668,346.3,668.9,331.1,658.4,320.6z M500.4,349.1c4.8,0,8.6,3.9,8.6,8.6c0,4.8-3.9,8.6-8.6,8.6c-4.8,0-8.6-3.9-8.6-8.6C491.8,353,495.7,349.1,500.4,349.1z M451.5,349.1c4.8,0,8.6,3.9,8.6,8.6c0,4.8-3.9,8.6-8.6,8.6c-4.8,0-8.6-3.9-8.6-8.6C442.9,353,446.7,349.1,451.5,349.1z"
});

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1920px",
    height: "1080px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6b300c40.svg";
export { ForwardRef as ReactComponent };